import React, { FC } from 'react';

interface SVGFbIconProps {
  width?: string;
  height?: string;
  color?: string;
}

const SVGFbIcon: FC<SVGFbIconProps> = ({
  width = '32',
  height = '32',
  color = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.375 12.6364H17.4938V10.7614C17.7 8.96761 20.6625 9.31136 20.6625 9.31136V6.21136C20.5625 6.21136 14.7687 4.81136 13.625 9.21761C13.4773 10.3509 13.4167 11.4938 13.4437 12.6364H11V16.0114H13.625V25.1864H17.45V16.0114H20.375L20.7063 12.6364H20.375Z"
      fill={color}
    />
  </svg>
);

export default SVGFbIcon;
